<script>
    import {onMount} from 'svelte';

    import store from '../../Stores/sede-store';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../Components/UI/Loading.svelte";
    import Error from "../../Components/UI/Error.svelte";
    import Titulo from "../../Components/UI/Titulo.svelte";
    import Migas from "../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../Components/Sedes/Edicion/Formulario.svelte";

    onMount(() => store.nueva());

    let error;
    $: error = $store.error;
</script>

<svelte:head>
    <title>Nueva sede</title>
</svelte:head>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }
</style>

<Migas>
    <Miga url={$url('/sedes')}>Sedes</Miga>
    <Miga actual>Nueva sede</Miga>
</Migas>

<Titulo>Nueva sede</Titulo>

{#if $store.cargando}
    <Loading/>
{:else}
    {#if error}
        <Error mensaje={error} on:cancel={() => error = null}/>
    {:else }
        <Formulario titulo="Datos de la nueva sede" on:enviado={() => $goto('/sedes')}/>
    {/if}
{/if}